module.exports = __webpack_public_path__ + "img/eq-2.199af331.png";